/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOfferCurrencies200ResponseData } from './getOfferCurrencies200ResponseData';


export interface GetOfferCurrencies200Response { 
    data?: GetOfferCurrencies200ResponseData;
}

